<template>
  <div class="page-container">
    <div class="container-box">

      <div class="page-top">
        <div class="top-img">
          <img src="../../assets/images/lottery/bg_top.png">
        </div>
      </div>

      <div class="page-center">
        <div class="page-title">
          本月奖池已累计<span>{{ couponCountAll }}</span>张奖券
        </div>

        <div class="page-content">
          <div class="content-box">
          <div class="content-text">
            <div class="context-text-icon">
              <img src="../../assets/images/lottery/pointer.png">
            </div>
            <span class="content-text-title">活动时间：</span>
            <span class="content-text-container">2021.01.01-2021.06.30</span>
          </div>
          <div class="content-text">
            <div class="context-text-icon">
              <img src="../../assets/images/lottery/pointer.png">
            </div>
            <span class="content-text-title">活动规则：</span>
            <span class="content-text-container">
              活动期间，用户扫博世产品码即可获得50积分，扫码满10次再随机获得一组抽奖券号用于抽奖，积分可以累积兑换好礼，多扫多得。开奖后，积分奖将于2个工作日内发放至中奖帐户中。
            </span>
          </div>
          <div class="content-text">
            <div class="context-text-icon">
              <img src="../../assets/images/lottery/pointer.png">
            </div>
            <span class="content-text-title">开奖时间：</span>
            <span class="content-text-container">
              首次开奖时间为2月1日，末次开奖时间为7月1日。每月1号开奖，中奖结果将公布在易加网以及易加网公众号，也可在卡包里查看是否中奖。
            </span>
            <div class="content-text-remark">(注：逢节假日或周末正常开奖)</div>
          </div>
          <div class="content-text">
            <div class="context-text-icon">
              <img src="../../assets/images/lottery/pointer.png">
            </div>
            <span class="content-text-title">奖项说明：</span>
            <div>一等奖：100万积分*1</div>
            <div>二等奖：10万积分*10</div>
            <div>三等奖：2万积分*50</div>
            <div>参与奖：5000积分*200</div>
          </div>
          <div class="new-rule">
          </div>
          </div>
        </div>
      </div>

      <div class="scan-box">
        <div class="page-btn" @click="scanCode">
          <img src="../../assets/images/lottery/bg_scan.png">
        </div>
      </div>
    </div>

    <div class="page-icon" @click="showList">
      <div class="page-icon-number">{{ couponCount }}</div>
    </div>

    <div class="extra-logo"></div>

    <!-- 弹窗-易加用户 -->
    <LotteryPopup ref="lotteryPopup" @popClick="scanCode"/>

    <!-- 弹窗-嘉实多用户 -->
    <LotteryPopupCastrol ref="lotteryPopupCastrol" @popClick="scanCode"/>

    <!-- 线下券 弹窗 -->
    <OfflinePopup ref="offlinePopup" />

  </div>
</template>

<script>
import LotteryPopup from './components/lottery-popup'
import LotteryPopupCastrol from './components/lottery-popup-castrol'
import OfflinePopup from './components/offline-popup'
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
import lotteryApi from '@/api/lottery'
export default {
  name: 'LotteryHome',
  components: {
    LotteryPopup,
    LotteryPopupCastrol,
    OfflinePopup
  },
  data () {
    return {}
  },
  computed: {
    couponCount () {
      return this.$store.state.lottery.couponCount
    },
    couponCountAll () {
      return this.$store.state.lottery.couponCountAll
    }
  },
  created () {
    this.clientInfo = userUtils.getClientInfo()
    if (!this.clientInfo) {
      window.location.href = commonUtils.getExtraSite() + '/#/login' + '?redirectUrl'
    } else {
      this.$store.dispatch('getCouponCount')
    }
    commonUtils.configWxJsSdk().catch(error => {
      this.$emit('error', { errorMsg: error })
    })
  },
  mounted () {
    const u = navigator.userAgent
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    console.log('isIOS', isIOS)
    if (isIOS && location.href.indexOf('#reloaded') === -1) {
      location.href = location.href + '#reloaded'
      location.reload()
    }
  },
  methods: {

    // 扫码
    scanCode () {
      // 测试
      // let code = {
      //   scanCode: '1WZVRCG6BYB77P39DP'
      // }
      // this.lotteryScan(code)
      // if (!this.clientInfo) {
      //   window.location.href = commonUtils.getExtraSite() + '/#/login' + '?redirectUrl'
      // }
      this.$wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['barCode', 'qrCode', 'datamatrix', 'pdf417'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          let scanData = {
            scanCode: res.resultStr
          }
          this.getLocation(scanData)
        },
        fail: res => {
          // this.$toast('调用扫码功能异常')
          console.log('fail', res)
        },
        cancel: function () {
          console.log('scan cancel')
        }
      })
    },

    // 获取经纬度
    getLocation (scanData) {
      this.$wx.getLocation({
        type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: res => {
          scanData.locLat = res.latitude // 纬度，浮点数，范围为90 ~ -90
          scanData.locLong = res.longitude // 经度，浮点数，范围为180 ~ -180。
          this.lotteryScan(scanData)
        },
        fail: function (err) {
          console.log(err)
        }
      })
    },

    // 扫码结果
    lotteryScan (value) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
      })
      lotteryApi.lotteryScan(value).then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          // 本次扫码数（连续扫码数）
          this.$store.commit('setScanCountCurrent')

          const data = res.data.resultData
          // 活动未开始或用户已获得4个字时 接口将不返回springActivity对象
          const springActivityData = data.springActivity || ''
          this.$store.commit('setCollectCardsData', springActivityData)
          // 博世码
          if (value.scanCode.indexOf('http://kd315.net/') === -1 &&
          value.scanCode.indexOf('https://cn-acf-sl.castrol.com/jsd_001') === -1) {
            this.$store.commit('setLotteryData', data)
            // this.$refs['lotteryPopup'].popAppear()
            if (typeof data.offlineCoupon !== 'undefined') {
              this.$refs['offlinePopup'].offlineAppear()
              setTimeout(() => {
                this.$refs['offlinePopup'].offlineHide()
                this.$refs['lotteryPopup'].popAppear()
              }, 3000)
            } else {
              this.$refs['lotteryPopup'].popAppear()
            }
          } else {
            // 嘉实多码
            this.$refs['lotteryPopupCastrol'].popAppear()
            this.$store.commit('setCastrolData', data)
          }
        } else {
          this.$notify({
            background: '#1989fa',
            message: res.data.resultMsg,
            className: 'notify-error-msg'
          })
        }
      }).catch(() => {
        this.$toast.clear()
      })
    },

    showList () {
      this.$router.push('/lottery/coupon')
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  height: 100%;
  width: 100%;
  min-height: 667px;
  background: url("../../assets/images/lottery/bg.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  // padding-top: 20px;
  box-sizing: border-box;
  .container-box {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .page-top {
    height: 200px;
    padding: 20px 5px 0px 5px;
    margin: auto;
    box-sizing: border-box;
    .page-img {
      width: 100%;
    }
  }
  .page-center {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .page-title {
    width: 189px;
    height: 50px;
    margin: 0 auto;
    padding-top: 10px;
    background: url('../../assets/images/lottery/head_hf.png');
    background-size: 100%;
    background-repeat: no-repeat;
    text-align: center;
    font-size: 13px;
    font-weight: bold;
    color: #fff;
    box-sizing: border-box;
    span {
      font-size: 16px;
      color: #fedd4f;
    }
  }
  .page-content {
    position: relative;
    width: 370px;
    height: 345px;
    margin: -2px auto 0px auto;
    background: url("../../assets/images/lottery/content.png") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 65px 35px 15px 40px;
    font-size: 12px;
    z-index: 10;
    .content-box {
      width: 100%;
      height: 100%;
      // position: relative;
      overflow-y: auto;
    }
    .content-text {
      margin-bottom: 10px;
      line-height: 16px;
      position: relative;
      .context-text-icon {
        display: inline-block;
        width: 4px;
        height: 11px;
        margin-right: 5px;
        // position: absolute;
        // left: -9px;
        // top: 1px
      }
      .content-text-title {
        color: #fe484c;
        font-weight: bold;
        position: relative;
      }
      .content-text-remark {
        color: #666;
      }
    }
    .new-rule {
      position: absolute;
      width: 176px;
      height: 128px;
      top: 60%;
      right: 0;
      background: url('../../assets/images/lottery/new_gift.png') no-repeat;
      background-size: 90%;
    }
  }
  .scan-box {
    width: 100%;
    height: 73px;
    // position: fixed;
    // bottom: 0px;
    // left: 50%;
    // transform: translateX(-50%);
  }
  .page-btn {
    width: 190px;
    height: 73px;
    margin: 0 auto;
    // position: fixed;
    // bottom: 0px;
    // left: 50%;
    // margin-left: -87px;
    z-index: 10;
  }
  .extra-logo {
    position: absolute;
    width: 90px;
    height: 50px;
    right: 15px;
    top: 0;
    background: url('../../assets/images/extra-logo.png');
    background-size: 100%;
  }
  .page-icon {
    width: 63px;
    height: 48px;
    background: url('../../assets/images/lottery/kq_icon.png') no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: 0;
    top: 195px;
    .page-icon-number {
      width: 22px;
      height: 22px;
      border-radius: 11px;
      background-color: #e3432d;
      line-height: 22px;
      text-align: center;
      margin-left: 38px;
      margin-top: 8px;
      color: #fff;
      font-size: 12px;
    }
  }
}
</style>
